import { useFormContext } from "react-hook-form"
import { FieldError } from "@motleyhand/design"

export default function FormError() {
  const {
    formState: { errors },
  } = useFormContext()
  const formError = errors.root?.formError?.message

  return !formError ? null : (
    <FieldError className="mb-4">{formError}</FieldError>
  )
}
